module.exports = __webpack_public_path__ + "img/Puente_Istobal_MNEX25_Alto_Blanco-default-back.c1f5fef9.jpg";